import type { AllMetricsObj } from '@pubstack/common/src/analytics/query'
import { sumObj } from '~/modules/analytics/common/formulas/operation-obj'

export const DATA_TYPES: { type: 'percentage' | 'number'; label: string }[] = [
  { type: 'number', label: '123' },
  { type: 'percentage', label: '%' },
]

type RawData<T = Record<string, number>> = {
  mappings: Record<string, string>
  impressionCpmSum: AllMetricsObj['impressionCpmSum']
} & T

export const getSortedKeysByImpression = <T>(rawData: RawData<T>, othersKey: string, shouldSlice: boolean = true, sliceCount: number = 5): string[] => {
  const sortedOrder = Object.entries(sumObj(rawData).impressionCpmSum)
    .filter(([key]) => key !== othersKey)
    .sort(([, a], [, b]) => b - a)
    .map(([key]) => key)

  const orderedKeys = shouldSlice ? sortedOrder.slice(0, sliceCount) : sortedOrder

  return Object.keys(rawData.mappings).length > sliceCount ? [...orderedKeys, othersKey] : orderedKeys
}

type RawDataServerSide<T = Record<string, number>> = {
  mappings: Record<string, string>
  serverSideImpressionCpmSum: AllMetricsObj['serverSideImpressionCpmSum']
} & T

export const getSortedKeysByServerSideImpression = <T>(rawData: RawDataServerSide<T>, othersKey: string, shouldSlice: boolean = true, sliceCount: number = 5): string[] => {
  const sortedOrder = Object.entries(sumObj(rawData).serverSideImpressionCpmSum)
    .filter(([key]) => key !== othersKey)
    .sort(([, a], [, b]) => b - a)
    .map(([key]) => key)

  const orderedKeys = shouldSlice ? sortedOrder.slice(0, sliceCount) : sortedOrder

  return Object.keys(rawData.mappings).length > sliceCount ? [...orderedKeys, othersKey] : orderedKeys
}
